import store from '@/store/index'
import { getABTProvider } from '@/plugins/abt/statsig'
import {
  vuePathToNextUrl,
  ADS_NEXTJS_APP_FEATURE_FLAG_NAME,
} from '@/utils/cross-app-routes'

// Check 2 cases:
// + When user switch to another merchant account => we should redirect back to dashboard page
// + When user is new => we should redirect to dashboard too
export default async function adsRouteGuard(to, from, next) {
  // If Next.js app is enabled, redirect to the equivalent Next.js route
  const abtProvider = getABTProvider()
  if (abtProvider.isFeatureEnabled(ADS_NEXTJS_APP_FEATURE_FLAG_NAME)) {
    const nextUrl = vuePathToNextUrl(to.path)
    const query =
      to.query && Object.keys(to.query).length
        ? '?' + new URLSearchParams(to.query).toString()
        : ''
    window.location.replace(
      window.location.origin + (nextUrl || '/ads/dashboard') + query
    )
    return
  }

  // To force advertiser already fetched before access any ads page
  await store.dispatch('ads/checkUserType')

  // If redirect back to ads dashboard then we can ignore the check
  // since ads dashboard is also the onboarding page for new adtech merchant
  if (to.path === '/ads/dashboard') {
    next()
    return
  }

  const selectedMerchant = localStorage.getItem('selectedMerchant')
  const adTechMerchant = localStorage.getItem('adTechMerchant')
  let proceedToNext = false

  // If the merchant is new (adTechMerchant null) or user select different merchant (adTechMerchant !== selectedMerchant)
  // then redirect to ads dashboard
  // If NOT then continue routing
  if (!adTechMerchant || adTechMerchant !== selectedMerchant) {
    // If advertiser didn't initialzed, should return undefined
    const isMerchantInitialized = await store.dispatch('ads/fetchAdvertiser')

    if (isMerchantInitialized) {
      localStorage.setItem('adTechMerchant', selectedMerchant)
      proceedToNext = true
    }
  } else {
    proceedToNext = true
  }

  next(proceedToNext ? undefined : '/ads/dashboard')
}
